import { Injectable } from '@angular/core';
import {
  AppConfigService,
  AppConfigValues,
  logLevels,
  LogLevelsEnum,
} from '@alfresco/adf-core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WkLogService {
  get currentLogLevel(): number {
    const configLevel: string = this.appConfig.get<string>(
      AppConfigValues.LOG_LEVEL
    );

    if (configLevel) {
      return this.getLogLevel(configLevel);
    }

    return LogLevelsEnum.TRACE;
  }

  getLogLevel(level: string): number {
    const referencedLevel = logLevels.find(
      (currentLevel: any) =>
        currentLevel.name.toLocaleLowerCase() === level.toLocaleLowerCase()
    );

    return referencedLevel ? referencedLevel.level : 5;
  }

  onMessage: Subject<any>;

  constructor(private readonly appConfig: AppConfigService) {
    this.onMessage = new Subject();
  }

  error(message?: any, ...optionalParams: any[]) {
    if (this.currentLogLevel >= LogLevelsEnum.ERROR) {
      this.messageBus(message, 'ERROR');

      console.error(message, ...optionalParams);
    }
  }

  info(message?: any, ...optionalParams: any[]) {
    if (this.currentLogLevel >= LogLevelsEnum.INFO) {
      this.messageBus(message, 'INFO');

      console.info(message, ...optionalParams);
    }
  }

  /**
   * Triggers notification callback for log messages.
   *
   * @param text Message text
   * @param logLevel Log level for the message
   */
  messageBus(text: string, logLevel: string) {
    this.onMessage.next({ text, type: logLevel });
  }
}
